var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title'),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":15},scopedSlots:_vm._u([{key:"item.entity_a",fn:function(ref){
var item = ref.item;
return [_c('entity-candidate',{attrs:{"ent-id":item.entity_a.id,"dictionary":item.entity_a.dictionary}})]}},{key:"item.entity_b",fn:function(ref){
var item = ref.item;
return [_c('entity-candidate',{attrs:{"ent-id":item.entity_b.id,"dictionary":item.entity_b.dictionary}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }